import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import { getProjectBySlug } from "@/data/projects";
import {
  ProjectBanner, ProjectScope, ProjectSidebar, ProjectHighlights,
} from "@/components/ProjectSections";

function NotFound() {
  return (
    <section className="ye-section" data-testid="project-not-found">
      <div className="ye-container" style={{ textAlign: "center", padding: "60px 0" }}>
        <span className="ye-eyebrow">404</span>
        <h1 className="ye-display ye-h2" style={{ margin: "8px 0 16px" }}>Project not found</h1>
        <p style={{ margin: "0 0 24px", color: "var(--ink)" }}>
          We couldn&apos;t find the project you were looking for.
        </p>
        <Link to="/projects" className="ye-btn ye-btn-primary" data-testid="back-to-projects">
          <ArrowLeft size={16} /> All Projects
        </Link>
      </div>
    </section>
  );
}

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = getProjectBySlug(slug);
  if (!project) return <NotFound />;

  return (
    <>
      <SEO
        title={`${project.title} | Projects | Yaduraj Enterprises`}
        description={project.summary.slice(0, 154)}
      />
      <ProjectBanner project={project} />

      <section className="ye-section">
        <div className="ye-container">
          <nav style={{ fontSize: 13.5, color: "#5b6577", marginBottom: 28 }} aria-label="Breadcrumb">
            <Link to="/projects">Projects</Link>
            <span style={{ margin: "0 8px" }}>/</span>
            <span style={{ color: "var(--ink)" }}>{project.title}</span>
          </nav>

          <div className="ye-project-grid">
            <div>
              <h2 className="ye-display ye-h3" style={{ fontSize: "1.5rem", margin: "0 0 14px" }}>Overview</h2>
              <div className="ye-prose" style={{ marginBottom: 36 }}>
                {project.overview.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
              </div>
              <ProjectScope scope={project.scope} />
            </div>
            <ProjectSidebar project={project} />
          </div>

          <ProjectHighlights highlights={project.highlights} />

          <div style={{ marginTop: 48 }}>
            <Link to="/projects" style={{ fontWeight: 600, color: "var(--navy)" }} data-testid="all-projects-link">
              <ArrowLeft size={14} style={{ display: "inline", verticalAlign: -2, marginRight: 6 }} />
              All Projects
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
